import {
  TEMPLATE_DEFAULT_LANGUAGE_OPTION,
  TEMPLATE_LANGUAGE_ALL_OPTION,
} from "./LanguageSelectionDropdown";

export const isAllLanguagesSelection = (languageCode) =>
  String(languageCode ?? "").toUpperCase() === TEMPLATE_LANGUAGE_ALL_OPTION.value;

/** English and All always refetch from the API when chosen in the dropdown. */
export const shouldAlwaysRefreshTemplatesSelection = (languageCode) => {
  const key = String(languageCode ?? "").toUpperCase();
  return (
    key === TEMPLATE_LANGUAGE_ALL_OPTION.value ||
    key === TEMPLATE_DEFAULT_LANGUAGE_OPTION.value.toUpperCase()
  );
};

/** Extract ISO language code from a get-language-code row. */
export const parseLanguageCodeFromItem = (item) => {
  const raw = item?.language ?? item?.Language ?? "";
  if (!raw) return null;
  const trimmed = String(raw).trim();
  const [codePart] = trimmed.split(" - ");
  return (codePart || trimmed).trim();
};

/** Collect unique language codes from the language-code API list. */
export const getLanguageCodesFromList = (languageCodes = []) => {
  if (!Array.isArray(languageCodes)) return [];
  return [
    ...new Set(
      languageCodes.map(parseLanguageCodeFromItem).filter(Boolean)
    ),
  ];
};

/** Merge template rows; dedupe by UniqueId, keyref, or composite key. */
export const mergeTemplatesUnique = (templates = []) => {
  const seen = new Set();
  const merged = [];

  templates.forEach((template) => {
    if (!template) return;
    const key =
      template.UniqueId ||
      template.keyref ||
      `${template.DocClass ?? ""}|${template.FormatSize ?? ""}|${template.LanguageCode ?? ""}|${template.DocNo ?? ""}`;

    if (seen.has(key)) return;
    seen.add(key);
    merged.push(template);
  });

  return merged;
};

export const normalizeTemplatesApiData = (response) => {
  if (!response) return [];
  if (response.status === 204) return [];
  const data = response.data;
  return Array.isArray(data) ? data : [];
};
